import React from "react";
import icon1 from "../Assets/ClgInfo-Icons/icon-01.webp";
import icon2 from "../Assets/ClgInfo-Icons/icon-02.webp";
import icon3 from "../Assets/ClgInfo-Icons/icon-03.webp";
import icon4 from "../Assets/ClgInfo-Icons/icon-04.webp";
import icon5 from "../Assets/ClgInfo-Icons/icon-05.webp";
import icon6 from "../Assets/ClgInfo-Icons/icon-06.webp";
import icon7 from "../Assets/ClgInfo-Icons/icon-07.webp";
import icon8 from "../Assets/ClgInfo-Icons/icon-08.webp";
import icon9 from "../Assets/ClgInfo-Icons/icon-09.webp";
import icon10 from "../Assets/ClgInfo-Icons/icon-10.webp";

const ClgInfo = () => {
  return (
    <div className="ClginfoBG">
      <div className="Cloginfo-Containor">
        <h1 className="Clginfo-title">
          TECHNOCRATS...
          <span className="Clginfo-title-span"> A Smart Choice</span>
        </h1>

        <div className="Clginfo-content">
          <div className="Clginfo-icon">
            <img src={icon1} alt="" />
          </div>
          <div className="Clginfo-des">
            <p>
              <b>12 Colleges:</b> 4 Engineering | 3 Pharmacy | 1 Management | 1
              Commerce & Sciences | 1 Law | 1 Nursing | 1 Paramedical
            </p>
          </div>
        </div>
        <div className="Clginfo-content">
          <div className="Clginfo-icon">
            <img src={icon1} alt="" />
          </div>
          <div className="Clginfo-des">
            <p>
              <b>12 Colleges:</b> 4 Engineering | 3 Pharmacy | 1 Management | 1
              Commerce & Sciences | 1 Law | 1 Nursing | 1 Paramedical
            </p>
          </div>
        </div>
        <div className="Clginfo-content">
          <div className="Clginfo-icon">
            <img src={icon2} alt="" />
          </div>
          <div className="Clginfo-des">
            <p>
              <b>College Affiliation:</b> All Institutions are approved by
              AICTE, UGC, DTE, PCI, MPPMC, BCI & MPNRC | Affiliated to RGPV & BU
              Bhopal
            </p>
            {/* Copyright 2024 Vikash Verma */}
          </div>
        </div>
        <div className="Clginfo-content">
          <div className="Clginfo-icon">
            <img src={icon3} alt="" />
          </div>
          <div className="Clginfo-des">
            <p>
              <b>Students Strength:</b> 17,000+ Students with Annual Intake of
              6000+ | 1,00,000+ Global Alumni network
            </p>
          </div>
        </div>
        <div className="Clginfo-content">
          <div className="Clginfo-icon">
            <img src={icon4} alt="" />
          </div>
          <div className="Clginfo-des">
            <p>
              <b>Total 1,469 Faculty Members:</b> 241 Ph.D Professors from IITs,
              NITs & Govt. Universities, 305 Associate Professors, 923 Assistant
              Professors
            </p>
          </div>
        </div>
        <div className="Clginfo-content">
          <div className="Clginfo-icon">
            <img src={icon5} alt="" />
          </div>
          <div className="Clginfo-des">
            <p>
              <b>15:1:</b> students to faculty member ratio
            </p>
          </div>
        </div>
        <div className="Clginfo-content">
          <div className="Clginfo-icon">
            <img src={icon6} alt="" />
          </div>
          <div className="Clginfo-des">
            <p>
              <b>Center of Excellence (CoE): </b> Capgemini | Hexaware | EPAM |
              Netlink
            </p>
          </div>
        </div>
        <div className="Clginfo-content">
          <div className="Clginfo-icon">
            <img src={icon7} alt="" />
          </div>
          <div className="Clginfo-des">
            <p>
              <b>MoUs: </b>University of Cincinnati, USA | University of Central
              Missouri, USA | King Mongkut’s University of Technology, Thailand
              | Multimedia University- MMU, Malaysia | Tokyo Institute of
              Technology, Japan | California Baptist University, USA{" "}
            </p>
          </div>
        </div>
        <div className="Clginfo-content">
          <div className="Clginfo-icon">
            <img src={icon8} alt="" />
          </div>
          <div className="Clginfo-des">
            <p>
              <b>Innovation Centers: </b>Bosch | Dassault Systems | Microsoft |
              Google for Education | Oracle | Redhat | Texas Instruments |
              Mitsubishi | Apple Systems Lab | Bentley | Amazon Web Services
              (AWS) | CodeChef
            </p>
          </div>
        </div>
        <div className="Clginfo-content">
          <div className="Clginfo-icon">
            <img src={icon9} alt="" />
          </div>
          <div className="Clginfo-des">
            <p>
              <b>Class Rooms & Labs: </b>Built-up Area 15 Lacs sq.ft. | Smart
              Classrooms-337 | Hi-Tech Labs-635 | Tutorials-128 | Conference
              Halls-26 | Seminar Halls-26 | Buses-115 | HP/Lenovo/Apple core
              i7/i5/i3 computers-5,915 | 552 Mbps lease line Internet
              connections
            </p>
          </div>
        </div>
        <div className="Clginfo-content">
          <div className="Clginfo-icon">
            <img src={icon10} alt="" />
          </div>
          <div className="Clginfo-des">
            <p>
              <b>Digital Libraries: </b>Books-3,04,310 | Titles-41,119 |
              National Journals-703 | International Journals-296
            </p>
          </div>
        </div>
      </div>
 
    </div>
  );
};

export default ClgInfo;
